<meta charset="utf-8">
<meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no">


<link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.4.1/css/bootstrap.min.css"
  integrity="sha384-Vkoo8x4CGsO3+Hhxv8T/Q5PaXtkKtu6ug5TOeNV6gBiFeWPGFN9MuhOf23Q9Ifjh" crossorigin="anonymous">



<div class="container-fluid">
  <div class="row">
    <h5 class="border-bottom">Abandoned Guides & Outfitters Apps</h5>
    <nav class="navbar navbar-light bg-light justify-content-between">
      <a class="navbar-brand"></a>
      <div class="input-group search-style">
        <input id="Search" class="form-control mr-sm-1" type="search" [(ngModel)]="searchTerm" placeholder="Search">
        <div class="input-group-append">
          <button class="btn removefocus" type="button" (click)="search()" *ngIf="!isSearching">
            <i class="fa fa-search"></i>
          </button>
          <button class="btn removefocus" type="button" (click)="clearSearch()" *ngIf="isSearching">
            <i class="fa fa-times"></i>
          </button>

        </div>
      </div>
    </nav>


    <section class="table-container" [ngClass]="{ 'table-container-collapsed':!dynamicTabService.isCollapsed}" tabindex="0">
      <table mat-table [dataSource]="dataSource" class="table table-bordered">
        <ng-container matColumnDef="startedDate">
          <th mat-header-cell *matHeaderCellDef>
            <button class="btn btn-link" (click)="sortData('startedDate')" matTooltip="Sort by Started Date">
              Started Date
              <i class="fa fa-fu" [class.fa-sort]="sortingColumn !== 'startedDate'"
                [class.fa-sort-asc]="sortingColumn === 'startedDate' && sortOrder === 'asc'"
                [class.fa-sort-desc]="sortingColumn === 'startedDate' && sortOrder === 'desc'"></i>
            </button>
          </th>
          <td mat-cell *matCellDef="let row">{{ row.startedDate | date:'short' }}</td>
        </ng-container>
        <ng-container matColumnDef="applicantName">
          <th mat-header-cell *matHeaderCellDef>
            <button class="btn btn-link" (click)="sortData('applicantName')" matTooltip="Sort by Applicant Name">
              Applicant Name
              <i class="fa fa-fu" [class.fa-sort]="sortingColumn !=='applicantName'"
                [class.fa-sort-asc]="sortingColumn ==='applicantName' && sortOrder === 'asc'"
                [class.fa-sort-desc]="sortingColumn ==='applicantName' && sortOrder === 'desc'"></i>
            </button>
          </th>
          <td mat-cell *matCellDef="let row">{{ row.applicantName }}</td>
        </ng-container>
        <ng-container matColumnDef="contactName">
          <th mat-header-cell *matHeaderCellDef>
            <button class="btn btn-link" (click)="sortData('contactName')" matTooltip="Sort by Contact Name">
              Contact Name
              <i class="fa fa-fu" [class.fa-sort]="sortingColumn !=='contactName'"
                [class.fa-sort-asc]="sortingColumn ==='contactName' && sortOrder === 'asc'"
                [class.fa-sort-desc]="sortingColumn ==='contactName' && sortOrder === 'desc'"></i>
            </button>
          </th>
          <td mat-cell *matCellDef="let row">{{ row.contactName }}</td>
        </ng-container>
        <ng-container matColumnDef="requestedEffectiveDate">
          <th mat-header-cell *matHeaderCellDef>
            <button class="btn btn-link" (click)="sortData('requestedEffectiveDate')"
              matTooltip="Sort by Requested Effect">
              Requested Effective Date
              <i class="fa fa-fu" [class.fa-sort]="sortingColumn !=='requestedEffectiveDate'"
                [class.fa-sort-asc]="sortingColumn ==='requestedEffectiveDate' && sortOrder === 'asc'"
                [class.fa-sort-desc]="sortingColumn ==='requestedEffectiveDate' && sortOrder === 'desc'"></i>
            </button>
          </th>
          <td mat-cell *matCellDef="let row">{{ row.requestedEffectiveDate| date: 'MM/dd/yyyy'}}</td>
        </ng-container>
        <ng-container matColumnDef="referralSourceId">
          <th mat-header-cell *matHeaderCellDef>
            <button class="btn btn-link" (click)="sortData('referralSourceId')" matTooltip="Sort by Referral Source">
              Referral Source
              <i class="fa fa-fu" [class.fa-sort]="sortingColumn !=='referralSourceId'"
                [class.fa-sort-asc]="sortingColumn ==='referralSourceId' && sortOrder === 'asc'"
                [class.fa-sort-desc]="sortingColumn ==='referralSourceId' && sortOrder === 'desc'"></i>
            </button>
          </th>
          <td mat-cell *matCellDef="let row">{{ row.referralSourceId }}</td>
        </ng-container>
        <ng-container matColumnDef="referralSourceDetails">
          <th mat-header-cell *matHeaderCellDef>
            <button class="btn btn-link" (click)="sortData('referralSourceDetails')"
              matTooltip="Sort by Referral Source Details">
              Referral Source Details
              <i class="fa fa-fu" [class.fa-sort]="sortingColumn !=='referralSourceDetails'"
                [class.fa-sort-asc]="sortingColumn ==='referralSourceDetails' && sortOrder === 'asc'"
                [class.fa-sort-desc]="sortingColumn ==='referralSourceDetails' && sortOrder === 'desc'"></i>
            </button>
          </th>
          <td mat-cell *matCellDef="let row">{{ row.referralSourceDetails }}</td>
        </ng-container>
        <ng-container matColumnDef="emailAddress">
          <th mat-header-cell *matHeaderCellDef>
            <button class="btn btn-link" (click)="sortData('emailAddress')" matTooltip="Sort by Email Address">
              Email Address
              <i class="fa fa-fu" [class.fa-sort]="sortingColumn !=='emailAddress'"
                [class.fa-sort-asc]="sortingColumn ==='emailAddress' && sortOrder === 'asc'"
                [class.fa-sort-desc]="sortingColumn ==='emailAddress' && sortOrder === 'desc'"></i>
            </button>
          </th>
          <td mat-cell *matCellDef="let row">{{ row.emailAddress }}</td>
        </ng-container>
        <ng-container matColumnDef="mainNumber">
          <th mat-header-cell *matHeaderCellDef>
            <button class="btn btn-link" (click)="sortData('mainNumber')" matTooltip="Sort by Main Number">
              Main Number
              <i class="fa fa-fu" [class.fa-sort]="sortingColumn !=='mainNumber'"
                [class.fa-sort-asc]="sortingColumn ==='mainNumber' && sortOrder === 'asc'"
                [class.fa-sort-desc]="sortingColumn ==='mainNumber' && sortOrder === 'desc'"></i>
            </button>
          </th>
          <td mat-cell *matCellDef="let row">{{ row.mainNumber }}</td>
        </ng-container>
        <ng-container matColumnDef="mobileNumber">
          <th mat-header-cell *matHeaderCellDef>
            <button class="btn btn-link" (click)="sortData('mobileNumber')" matTooltip="Sort by Mobile Number">
              Mobile Number
              <i class="fa fa-fu" [class.fa-sort]="sortingColumn !=='mobileNumber'"
                [class.fa-sort-asc]="sortingColumn ==='mobileNumber' && sortOrder === 'asc'"
                [class.fa-sort-desc]="sortingColumn ==='mobileNumber' && sortOrder === 'desc'"></i>
            </button>
          </th>
          <td mat-cell *matCellDef="let row">{{ row.mobileNumber }}</td>
        </ng-container>
        <ng-container matColumnDef="faxNumber">
          <th mat-header-cell *matHeaderCellDef>
            <button class="btn btn-link" (click)="sortData('faxNumber')" matTooltip="Sort by Fax Number">
              Fax Number
              <i class="fa fa-fu" [class.fa-sort]="sortingColumn !=='faxNumber'"
                [class.fa-sort-asc]="sortingColumn ==='faxNumber' && sortOrder === 'asc'"
                [class.fa-sort-desc]="sortingColumn ==='faxNumber' && sortOrder === 'desc'"></i>
            </button>
          </th>
          <td mat-cell *matCellDef="let row">{{ row.faxNumber }}</td>
        </ng-container>
        <ng-container matColumnDef="website">
          <th mat-header-cell *matHeaderCellDef>
            <button class="btn btn-link" (click)="sortData('website')" matTooltip="Sort by Website">
              Website
              <i class="fa fa-fu" [class.fa-sort]="sortingColumn !=='website'"
                [class.fa-sort-asc]="sortingColumn ==='website' && sortOrder === 'asc'"
                [class.fa-sort-desc]="sortingColumn ==='website' && sortOrder === 'desc'"></i>
            </button>
          </th>
          <td mat-cell *matCellDef="let row">{{ row.website }}</td>
        </ng-container>
        <ng-container matColumnDef="address1">
          <th mat-header-cell *matHeaderCellDef>
            <button class="btn btn-link" (click)="sortData('address1')" matTooltip="Sort by Address1">
              Address1
              <i class="fa fa-fu" [class.fa-sort]="sortingColumn !=='address1'"
                [class.fa-sort-asc]="sortingColumn ==='address1' && sortOrder === 'asc'"
                [class.fa-sort-desc]="sortingColumn ==='address1' && sortOrder === 'desc'"></i>
            </button>
          </th>
          <td mat-cell *matCellDef="let row">{{ row.address1 }}</td>
        </ng-container>
        <ng-container matColumnDef="address2">
          <th mat-header-cell *matHeaderCellDef>
            <button class="btn btn-link" (click)="sortData('address2')" matTooltip="Sort by Address2">
              Address2
              <i class="fa fa-fu" [class.fa-sort]="sortingColumn !=='address2'"
                [class.fa-sort-asc]="sortingColumn ==='address2' && sortOrder === 'asc'"
                [class.fa-sort-desc]="sortingColumn ==='address2' && sortOrder === 'desc'"></i>
            </button>
          </th>
          <td mat-cell *matCellDef="let row">{{ row.address2 }}</td>
        </ng-container>
        <ng-container matColumnDef="city">
          <th mat-header-cell *matHeaderCellDef>
            <button class="btn btn-link" (click)="sortData('city')">
              City
              <i class="fa fa-fu" [class.fa-sort]="sortingColumn !=='city'"
                [class.fa-sort-asc]="sortingColumn ==='city' && sortOrder === 'asc'"
                [class.fa-sort-desc]="sortingColumn ==='city' && sortOrder === 'desc'"></i>
            </button>
          </th>
          <td mat-cell *matCellDef="let row">{{ row.city }}</td>
        </ng-container>
        <ng-container matColumnDef="stateId">
          <th mat-header-cell *matHeaderCellDef>
            <button class="btn btn-link" (click)="sortData('stateId')">
              State
              <i class="fa fa-fu" [class.fa-sort]="sortingColumn !=='stateId'"
                [class.fa-sort-asc]="sortingColumn ==='stateId' && sortOrder === 'asc'"
                [class.fa-sort-desc]="sortingColumn ==='stateId' && sortOrder === 'desc'"></i>
            </button>
          </th>
          <td mat-cell *matCellDef="let row">{{ row.stateId }}</td>
        </ng-container>
        <ng-container matColumnDef="postalCode">
          <th mat-header-cell *matHeaderCellDef>
            <button class="btn btn-link" (click)="sortData('postalCode')">
              Postal
              <i class="fa fa-fu" [class.fa-sort]="sortingColumn !=='postalCode'"
                [class.fa-sort-asc]="sortingColumn ==='postalCode' && sortOrder === 'asc'"
                [class.fa-sort-desc]="sortingColumn ==='postalCode' && sortOrder === 'desc'"></i>
            </button>
          </th>
          <td mat-cell *matCellDef="let row">{{ row.postalCode }}</td>
        </ng-container>
        <ng-container matColumnDef="descriptionOfOperations">
          <th mat-header-cell *matHeaderCellDef>
            <button class="btn btn-link" (click)="sortData('descriptionOfOperations')">
              Description Of Operations
              <i class="fa fa-fu" [class.fa-sort]="sortingColumn !=='descriptionOfOperations'"
                [class.fa-sort-asc]="sortingColumn ==='descriptionOfOperations' && sortOrder === 'asc'"
                [class.fa-sort-desc]="sortingColumn ==='descriptionOfOperations' && sortOrder === 'desc'"></i>
            </button>
          </th>
          <td mat-cell *matCellDef="let row">{{ row.descriptionOfOperations }}</td>
        </ng-container>
        <ng-container matColumnDef="yearsInOperation">
          <th mat-header-cell *matHeaderCellDef>
            <button class="btn btn-link" (click)="sortData('yearsInOperation')">
              Years In Operation
              <i class="fa fa-fu" [class.fa-sort]="sortingColumn !=='yearsInOperation'"
                [class.fa-sort-asc]="sortingColumn ==='yearsInOperation' && sortOrder === 'asc'"
                [class.fa-sort-desc]="sortingColumn ==='yearsInOperation' && sortOrder === 'desc'"></i>
            </button>
          </th>
          <td mat-cell *matCellDef="let row">{{ row.yearsInOperation }}</td>
        </ng-container>
        <ng-container matColumnDef="priorExperience">
          <th mat-header-cell *matHeaderCellDef>
            <button class="btn btn-link" (click)="sortData('priorExperience')">
              Prior Experience
              <i class="fa fa-fu" [class.fa-sort]="sortingColumn !=='priorExperience'"
                [class.fa-sort-asc]="sortingColumn ==='priorExperience' && sortOrder === 'asc'"
                [class.fa-sort-desc]="sortingColumn ==='priorExperience' && sortOrder === 'desc'"></i>
            </button>
          </th>
          <td mat-cell *matCellDef="let row">{{ row.priorExperience }}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="columnsToDisplay;sticky:true" class="headerstyle"></tr>
        <tr mat-row *matRowDef="let row; columns: columnsToDisplay"></tr>
      </table>
    </section>
    <!-- Pagination -->
    <div>
      <mat-paginator class="pagination" [length]="totalItems" [hidePageSize]="isHidePageSize"
      [showFirstLastButtons]="showFirstLastButtons" (page)="onPageChange($event)" aria-label="Select page">
      </mat-paginator>
    </div>
  </div>
  <!-- Table spinner -->
  <div *ngIf="isLoading" class="spinner-wrapper">
    <mat-spinner diameter="32" color="primary"></mat-spinner>
  </div>
</div>